import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Content, Grid, Icon } from '@/components'

const Wrapper = styled.div`
  color: #666666;
  font-size: 12px;
  font-weight: 500;

  border-bottom: 1px solid #cdcdcd;
  .hospital-header-inner {
    padding: 11px 16px;
    justify-content: space-between;
    align-items: center;
  }

  .hospital-list-order {
    flex: inherit;
    display: flex;
    align-items: center;
  }
  .hospital-list-order > * {
    display: inline-block;
  }
`

interface Props {
  totalHospitalCount: number
}

const HospitalHeader = ({ totalHospitalCount }: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Content>
        <Grid $padding={16} className="hospital-header-inner">
          <span>
            {t('components.hospitalHeader.contents.hospitalList')} ({totalHospitalCount.toLocaleString()})
          </span>

          <span className="hospital-list-order">
            <Icon size={24} name="sort_arrow" />
            {t('components.hospitalHeader.contents.rating')}
          </span>
        </Grid>
      </Content>
    </Wrapper>
  )
}

export default HospitalHeader
